import { Controller } from '@hotwired/stimulus'

// Open during the submit gesture so the browser allows the new tab, then
// point it at the URL only after the save succeeds.
export default class extends Controller {
  static values = { url: String }

  prepareWindow () {
    this.pendingWindow = window.open('about:blank', '_blank')
  }

  open (event) {
    if (!event.detail.success) {
      this.closePendingWindow()
      return
    }

    if (!this.pendingWindow) return

    this.pendingWindow.location.href = this.urlValue
    this.pendingWindow = null
  }

  disconnect () {
    this.closePendingWindow()
  }

  closePendingWindow () {
    this.pendingWindow?.close()
    this.pendingWindow = null
  }
}
